import { definePolicy, listQuerySchema } from '@britania/teams-kit-core';
import { pendingApprovalTicketSchema } from '#src/tickets/pending-approval-tickets.contract.js';
const text = {
    type: 'string',
    wildcards: true,
    caseInsensitive: true,
};
/**
 * O que `GET /api/tickets/pending-approval` deixa filtrar, ordenar e pedir.
 * `approvers.*` vale quando algum aprovador do chamado bate.
 */
export const pendingApprovalTicketsPolicy = definePolicy({
    fields: {
        id: { type: 'integer', sortable: true },
        number: { ...text, sortable: true },
        title: { ...text, sortable: true },
        'requester.name': text,
        'requester.email': text,
        'approvers.name': text,
        'approvers.email': text,
    },
    defaultSort: [{ field: 'id', direction: 'asc' }],
    selectable: pendingApprovalTicketSchema.keyof().options,
});
export const pendingApprovalTicketsQuerySchema = listQuerySchema(pendingApprovalTicketsPolicy);
//# sourceMappingURL=pending-approval-tickets.policy.js.map